// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__uw29-","tabLabel":"styles_tabLabel__ZxQk3","tabContent":"styles_tabContent__6ptBc","input":"styles_input__9uSIK"};